import { Box, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { SpreadJoyProps } from '../interfaces/components';
import { LoccitaneClose } from '../Icons/LoccitaneClose';
import { SpreadJoyModal } from '../content';
import { Share } from '../Icons/Share';

const SpreadJoy = ({ activeLocale, active, setActive }: SpreadJoyProps) => {
  const [isCopied, setIsCopied] = useState(false);
  const [showCode, setShowCode] = useState(false);

  const handleCopyClick = () => {
    setShowCode(true);
    navigator.clipboard
      .writeText('JOY')
      .then(() => {
        setIsCopied(true);
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
      });

    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.5)"
        transition="all 1s"
        zIndex="9"
        onClick={() => {
          setActive();
        }}
      />

      <Box
        zIndex="10"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        bg="white"
        padding={['15px', '20px', '25px', '25px']}
        width={['90vw', '360px', '400px', '730px', '800px']}
        height={['350px', '450px', '500px', '430px', '450px']}
      >
        <LoccitaneClose
          boxSize={[6, 6, 8]}
          position="absolute"
          top={['25px', '30px', '35px']}
          right={['25px', '30px', '35px']}
          cursor="pointer"
          fill="black"
          strokeWidth={0.5}
          onClick={() => {
            setActive();
          }}
          zIndex={30}
          stroke="#CCCCCC"
          borderRadius="100%"
          _hover={{ stroke: 'black' }}
          transition=".5s"
        />

        <Box
          border="5px solid #FFCB00"
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
        >
          <Box
            textAlign="center"
            w="100%"
            h="100%"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Text
              mt={['20px', '20px', '20px', '20px']}
              w={['80%', '240px', '300px', 'unset']}
              fontSize={['20px', '25px', '30px', '35px', '40px']}
              lineHeight={['20px', '25px', '30px', '35px', '40px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'LoccitaneRegular'}
              fontWeight="500"
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof SpreadJoyModal) in SpreadJoyModal)
                ? SpreadJoyModal['en'].textOne
                : SpreadJoyModal[activeLocale as keyof typeof SpreadJoyModal].textOne}
            </Text>

            <Box m={['15px 0px', '15px 0px', '20px 0px', '20px 0px']} textAlign="center">
              <Text
                textAlign="center"
                w={['180px', '220px', '250px', 'unset']}
                fontSize={['12px', '13px', '15px', '16px', '18px']}
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
              >
                {activeLocale === undefined || !((activeLocale as keyof typeof SpreadJoyModal) in SpreadJoyModal)
                  ? SpreadJoyModal['en'].textTwo
                  : SpreadJoyModal[activeLocale as keyof typeof SpreadJoyModal].textTwo}
              </Text>
              <Text
                textAlign="center"
                w={['180px', '220px', '250px', 'unset']}
                fontSize={['12px', '13px', '15px', '16px', '18px']}
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
              >
                {activeLocale === undefined || !((activeLocale as keyof typeof SpreadJoyModal) in SpreadJoyModal)
                  ? SpreadJoyModal['en'].textThree
                  : SpreadJoyModal[activeLocale as keyof typeof SpreadJoyModal].textThree}
              </Text>
            </Box>

            <Box
              width={['180px', '200px', '280px', '280px', '300px']}
              height={['40px', '45px', '45px', '45px', '50px']}
              backgroundSize="35px 35px, 0 0, 0 0, 100% 100%"
              backgroundPosition="100% 0, 0 0, 100% 100%, 100% 0"
              backgroundRepeat="no-repeat"
              border={showCode ? '2px solid #FDC506' : '2px solid black'}
              bg={showCode ? '#FDC506' : 'transparent'}
              display="flex"
              justifyContent="center"
              alignItems="center"
              transition="0.5s all"
            >
              <Text
                fontSize={['12px', '13px', '14px', '14px', '16px']}
                lineHeight={['12px', '13px', '14px', '14px', '16px']}
                fontFamily="RalewayMedium"
                fontWeight="900"
                textTransform="uppercase"
              >
                {showCode
                  ? activeLocale === undefined || !((activeLocale as keyof typeof SpreadJoyModal) in SpreadJoyModal)
                    ? SpreadJoyModal['en'].textFourSucc
                    : SpreadJoyModal[activeLocale as keyof typeof SpreadJoyModal].textFourSucc
                  : activeLocale === undefined || !((activeLocale as keyof typeof SpreadJoyModal) in SpreadJoyModal)
                  ? SpreadJoyModal['en'].textFour
                  : SpreadJoyModal[activeLocale as keyof typeof SpreadJoyModal].textFour}
              </Text>
            </Box>

            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              mt={['20px', '20px', '40px', '30px', '40px']}
              onClick={() => handleCopyClick()}
              cursor="pointer"
            >
              <Box
                bg="#FDC506"
                aria-label="To Spread Joy"
                boxSize={[9, 9, 10, 10]}
                borderRadius="100%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                marginLeft="auto"
                _hover={{
                  bg: '#F9DD7D',
                }}
                transition="0.5s"
                cursor="pointer"
              >
                <Share boxSize={[5, 5, 6, 6]} />
              </Box>
              <Text
                ml={['5px', '5px', '10px', '10px']}
                fontSize={['14px', '14px', '18px', '20px', '22px']}
                lineHeight={['14px', '14px', '18px', '20px', '22px']}
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayBold'}
                fontWeight="900"
                textTransform="uppercase"
              >
                {isCopied
                  ? activeLocale === undefined || !((activeLocale as keyof typeof SpreadJoyModal) in SpreadJoyModal)
                    ? SpreadJoyModal['en'].copied
                    : SpreadJoyModal[activeLocale as keyof typeof SpreadJoyModal].copied
                  : activeLocale === undefined || !((activeLocale as keyof typeof SpreadJoyModal) in SpreadJoyModal)
                  ? SpreadJoyModal['en'].button
                  : SpreadJoyModal[activeLocale as keyof typeof SpreadJoyModal].button}
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
export default SpreadJoy;
